import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AlertService } from '@client-libs';
import { UserStore } from '../../../stores/user.store';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class TopBar {
  readonly alertService = inject(AlertService);
  readonly userStore = inject(UserStore);
  readonly router = inject(Router);

  user = this.userStore.user;
  header = input.required<string>();
  description = input<string>();

  logout() {
    this.alertService
      .open({
        title: '로그아웃',
        content: '로그아웃 하시겠습니까?',
        type: 'info',
      })
      .closed.subscribe({
        next: async result => {
          if (result?.action === 'confirm') {
            await this.userStore.logout();
            this.router.navigate(['/sign-in']);
          }
        },
      });
  }
}
